//Empty to fix anonymous module error
;
define("jquery/ui-modules/core", function(){});

